module.exports = __webpack_public_path__ + "static/img/one.c51b5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/5/one.png
// module id = EPW1
// module chunks = 1